import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar'
import { useS3DownloadUrlQuery } from '@/lib/hooks/s3'

interface ProfileAvatarProps {
  photoS3Key?: string | null
  avatarColor?: string | null
  initials: React.ReactNode
  className?: string
  fallbackClassName?: string
}

/**
 * Avatar that self-resolves a photoS3Key into a signed URL. Falls back to the
 * initials-on-avatarColor treatment used across the app while the photo loads
 * or when no photo is set.
 */
export function ProfileAvatar({
  photoS3Key,
  avatarColor,
  initials,
  className,
  fallbackClassName,
}: ProfileAvatarProps) {
  // Avatars render at <=72px, so the 400px 'thumb' variant is plenty; photos
  // uploaded before variants existed fall back to the original.
  const { data } = useS3DownloadUrlQuery(photoS3Key, { variant: 'thumb' })
  const urls = data as { downloadUrl?: string; thumbnailUrl?: string } | undefined
  const downloadUrl = urls?.thumbnailUrl ?? urls?.downloadUrl

  return (
    <Avatar className={className}>
      {downloadUrl && <AvatarImage src={downloadUrl} className="object-cover" />}
      <AvatarFallback
        className={fallbackClassName}
        style={avatarColor ? { backgroundColor: avatarColor } : undefined}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  )
}
